import { REPUBS } from '@cx-modules/constants';

export const navItemType = {
	LINK: 'LINK',
	ALL_SPORTS_EXPANDABLE: 'ALL_SPORTS_EXPANDABLE',
	FEATURED_LINKS: 'FEATURED_LINKS',
	GROUP: 'GROUP',
	SPLIT_EXPANDABLE: 'SPLIT_EXPANDABLE',
	FLAT_ITEMS_EXPANDABLE: 'FLAT_ITEMS_EXPANDABLE',
	DISCLAIMER: 'DISCLAIMER',
};

export const excludedRegionsFromHeaderFooterV2 = new Set([
	REPUBS.CO.name,
	REPUBS.OC.name,
	REPUBS.US.name,
	REPUBS.XX.name,
]);
